import { createRouteMap as createRouteMapMain } from '../components/main';
import { createRouteMap as createRouteMapHauler } from '../components/hauler';

import { pathJoin } from '../routing/utils';

export const createRoutesMap = (prefix: string) => ({
  login: pathJoin(prefix)(`login`).chain,
  'error-test': pathJoin(prefix)(`error-test`).chain,
  app: pathJoin(prefix).chainMap(
    createRouteMapMain(pathJoin(prefix).value.slice(1))
  ),
  hauler: pathJoin(prefix)(`hauler`).chainMap(
    createRouteMapHauler(pathJoin(prefix)(`hauler`).value.slice(1))
  ),
  calendar: pathJoin(prefix)(`calendar`).chain,
});
